import { store } from '@/state/store';
import { UTILS__graph_ui } from '@/utils/UTILS__graph_ui';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { Node } from '@xyflow/react';

export function FN_GRAPH_UPDATE__node_remove(nodes_data: Node[], graph: DTO_GRAPH__instance) {
  let nodes_ids = nodes_data.map(node => node.id);

  for (let node_id of nodes_ids) {
    graph.node__delete(node_id);
  }

  let { g_graph__node_id_selected } = store.getState().slice_ui;

  if (nodes_ids.includes(g_graph__node_id_selected)) UTILS__graph_ui.node__deselect();

  return true; //need to update graph remotely
}
